import FileUtils from 'application/utils/FileUtils';
import { getMediaPreviewKind } from 'application/utils/MediaPreviewUtils';
import type { IVideoStreamItem } from '../types';
import type { MediafilePreviewResource } from './previewTypes';

export const resolveMediafilePreviewResource = (item: IVideoStreamItem): MediafilePreviewResource | undefined => {
  if (item.itemType === 'emenu') return undefined;
  // EDIT carries a stream link with nested media; CREATE selects a raw library file.
  const { uri, type, sourcefiles } = item.mediafile ?? item;
  if (!uri) return undefined;
  const source = FileUtils.getSourcefileByUrl(sourcefiles, uri);
  const kind = getMediaPreviewKind({ type, extension: source?.extension });
  return kind ? { id: item.id, uri, kind } : undefined;
};
